import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { HiddenOnlyAuth, VisibleOnlyAuth } from './util/wrappers.js'
import { logoutUser } from './user/actions/LogoutAction'
import {
  Container,
  Header,
  Menu,
  Segment,
  Dimmer, 
  Loader,
  Icon,
  Popup
} from 'semantic-ui-react'

// Styles
import './css/App.css'

class App extends Component {

    onLogoutUserClick(){
		
        let { dispatch } = this.props
		
        dispatch(logoutUser())
    }

    render() {

        let { web3, children } = this.props

        const OnlyAuthLinks = VisibleOnlyAuth(() =>
            <Container>
                <Menu.Item as={Link} to='/my-wallet'>My Wallet</Menu.Item>
                <Menu.Item as={Link} to='/token'>Token</Menu.Item>
                <Menu.Item as={Link} to='/city'>City</Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item as={Link} to='/usage'>Usage</Menu.Item>
                    <Popup trigger={<Menu.Item as={Link} to='#' onClick={() => this.onLogoutUserClick()}><Icon name='sign out' /></Menu.Item>} content='Logout'/>
                </Menu.Menu>
            </Container>
		)

        const OnlyGuestLinks = HiddenOnlyAuth(() =>
            <Container>
                <Menu.Item as={Link} to='/' header>Atlantida Solutions</Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item as={Link} to='/wallet'>Wallet</Menu.Item>
                    <Menu.Item as={Link} to='/usage'>Usage</Menu.Item>
                </Menu.Menu>
            </Container>
		)
		
        const Footer = () => (
            <div>
                <Segment inverted vertical style={{ padding: '4em 0em' }}>
                    <Container textAlign='center' text>
                        <Header inverted sub>Like it? Write to <a href='https://www.facebook.com/nparfenchuk/' target='_blank'>creator</a></Header>
                        <Header inverted sub>Made with love</Header>
                    </Container>
                </Segment>
            </div>
		)
		
        if(!web3.isLoaded){
            return(
                <Dimmer active>
                    <Loader size='huge'/>
                </Dimmer>	
			)
        } else {
            return (
                <div>
                    <Menu size='huge' borderless>
                        <OnlyGuestLinks />
                        <OnlyAuthLinks />
                    </Menu>
                    {children}
                    <Footer />
                </div>
			)
        }
    }
}


function mapStateToProps(state) {
    return {
        web3: state.web3
    }
}

export default connect(mapStateToProps)(App);


App.propTypes = {
    children: PropTypes.element,
    web3: PropTypes.object,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/App.js